import { injectable } from 'inversify';
import * as Api from '@xlearn/common';
import competenceStoreModule from './competence-state';
import aspectStoreModule from '@/app/aspect/apsect-state';
import objectCompletionStoreModule from '@/app/statistics/state/object-completion-state';

@injectable()
export class CompetenceService {
  public calculateAndSetToStore(): void {
    if (!aspectStoreModule.selectedCourseAspectInstance) {
      return;
    }

    aspectStoreModule.selectedCourseAspectInstance.competences.forEach((c: Api.SerializedCompetence) => {
      const progress = Api.competenceProgress(c.references, (objectIds: string[]): number[] => {
        return objectIds.map((objectId) =>
          objectCompletionStoreModule.completedObjectIds.includes(objectId) ? 1 : 0);
      });

      competenceStoreModule.percentsByCompetences[c.name] = progress;
    });
  }

  public getTotalPercent(): number {
    const values: number[] = Object.values(competenceStoreModule.percentsByCompetences);
    const length: number = values.length;
    if (length === 0) {
      return 0;
    }

    const sum: number = values.reduce((total: number, current: number) => total + current, 0);
    return Math.round(100 * sum / length);
  }

  public getPercentsByCompetences(): { [name: string]: number } {
    const withPercents: { [name: string]: number } = {};
    Object.entries(competenceStoreModule.percentsByCompetences).forEach(([name, progress]) => {
      withPercents[name] = Math.round(100 * progress);
    });
    return withPercents;
  }
}

export const CompetenceServiceSymbol = Symbol.for('CompetenceService');
